import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=dark%20cinematic%20movie%20theater%20atmosphere%20with%20abstract%20warm%20golden%20particles%20floating%20in%20air%2C%20luxurious%20dark%20velvet%20curtain%20texture%2C%20dramatic%20stage%20lighting%2C%20elegant%20cinema%20aesthetic%2C%20rich%20amber%20and%20deep%20black%20tones%2C%204K%20cinematic%20composition&width=1920&height=800&seq=hero-bg-main&orientation=landscape"
        alt="天美麻花星空影视 - 高清免费在线观影"
        title="天美麻花星空影视免费观看 - 麻花星空影视免费观看高清不缓冲"
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-950" />

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight tracking-tight">
              天美麻花星空影视
              <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-2 text-foreground-200">
                免费观看高清不缓冲流畅播放
              </span>
            </h1>
            <p className="text-foreground-300 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
              极速观看免费影视大全，最新电影电视剧免费在线。汇聚海量高清影片，不卡顿不缓冲，
              为您提供极致的在线观影体验。随时随地，想看就看！
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-400 transition-all duration-300 whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即观影
              </Link>
              <Link
                to="/category/movie"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full border border-white/20 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-film-line"></i>
                热门电影
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <div className="animate-bounce w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}